import RemoveTailoredExperienceEventsFromCalendarJsonResponse from 'owa-service/lib/contract/RemoveTailoredExperienceEventsFromCalendarJsonResponse';
import removeTailoredExperienceEventsFromCalendarOperation from 'owa-service/lib/operation/removeTailoredExperienceEventsFromCalendarOperation';
import ItemId from 'owa-service/lib/contract/ItemId';
import itemId from 'owa-service/lib/factory/itemId';
import removeTailoredExperienceEventsFromCalendarRequest from 'owa-service/lib/factory/removeTailoredExperienceEventsFromCalendarRequest';
import removeTailoredExperienceEventsFromCalendarJsonRequest from 'owa-service/lib/factory/removeTailoredExperienceEventsFromCalendarJsonRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { trace } from 'owa-trace';
import { format } from 'owa-strings';

/**
 *
 * This function makes the EWS service call to remove Txp events from calendar
 *
 */
export default function removeTxpEventsFromCalendar(
    itemid: string
): Promise<RemoveTailoredExperienceEventsFromCalendarJsonResponse> {
    let itemBody: ItemId = { Id: itemid };
    let itemIdBody = { ItemIds: [itemId(itemBody)] };

    return removeTailoredExperienceEventsFromCalendarOperation(
        removeTailoredExperienceEventsFromCalendarJsonRequest({
            Header: getJsonRequestHeader(),
            Body: removeTailoredExperienceEventsFromCalendarRequest(itemIdBody),
        })
    )
        .then(response => response)
        .catch(error => {
            trace.error(
                format(
                    '[TXP] Error when calling RemoveTxpEventsToCalendar EWS API, error: {0}',
                    error
                )
            );
            return null;
        });
}
